// Section8CompanyRegistration.jsx
import React from "react";

export default function Section8CompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Section 8 Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Section 8 Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in Section 8 Company Registration for
            non-profit objectives, helping promote charitable, educational,
            social, and other not-for-profit activities through a corporate
            structure.
          </p>
          <p className="text-gray-700">
            From planning your non-profit objectives and drafting core company
            documents to organizing director details and filings, the process is
            managed in a structured way so your Section 8 entity can be
            incorporated with full legal clarity.
          </p>
        </div>

        {/* Right: Image (square for consistency) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6647118/pexels-photo-6647118.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Non-profit team discussing Section 8 company registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Section 8 Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps founders and directors compile and
              structure the details and proofs needed to register a Section 8
              company with the Ministry of Corporate Affairs.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN card of all proposed directors and subscribers /
                  shareholders.
                </li>
                <li>
                  Identity and address proof of directors (Aadhaar, passport,
                  voter ID, driving licence, recent bank statement or utility
                  bill).
                </li>
                <li>
                  Registered office proof (rent/lease agreement or ownership
                  document, latest utility bill, and NOC from owner where
                  applicable).
                </li>
                <li>
                  Draft Memorandum of Association (MOA) and Articles of
                  Association (AOA) reflecting Section 8 non-profit objects.
                </li>
                <li>
                  Passport-size photographs and contact details of all directors
                  and key promoters.
                </li>
                <li>
                  Basic outline of proposed activities and estimated income and
                  expenditure for the initial years, if required.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers non-profit focused support, combining knowledge of
              Section 8 provisions with practical experience in incorporation
              and early-stage compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Specialized Non-Profit Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance tailored to non-profit objectives, including
                  appropriate object clauses, naming conventions, and governance
                  suited to a Section 8 company.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Full MCA Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in preparing incorporation forms and attachments in
                  line with MCA requirements, helping avoid queries and
                  resubmissions during the approval process.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Incorporation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from initial planning and documentation
                  through filing and incorporation, with clear communication and
                  professional handling at each step.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
